import { useState } from 'react';

const useModalState = () => {
  const [openPrinterModal, setOpenPrinterModal] = useState(false);
  const [openUnexpectedItemModal, setOpenUnexpectedItemModal] = useState(false);
  const [apiResponseModal, setApiResponseModal] = useState(false);
  const [printRouteConfirmation, setPrintRouteConfirmation] = useState(false);
  const [closeRouteConfirmation, setCloseRouteConfirmation] = useState(false);
  const [forceCloseModal, setForceModal] = useState(false);

  return {
    openPrinterModal,
    setOpenPrinterModal,
    openUnexpectedItemModal,
    setOpenUnexpectedItemModal,
    apiResponseModal,
    setApiResponseModal,
    printRouteConfirmation,
    setPrintRouteConfirmation,
    closeRouteConfirmation,
    setCloseRouteConfirmation,
    forceCloseModal,
    setForceModal,
  };
};

export default useModalState;
